export enum profile_name {
  admin = 'Administrador',
  admin_employer = 'Administrador Colegio',
  employer = 'Colegio',
  employee = 'Profesor',
  accountant = 'accountant',
  prospection = 'prospection'
}

export enum role_employer {
  admin = 'admin',
  recruiter = 'recruiter',
  complaint = 'complaint',
  psychologist = 'psychologist',
}
export const userRoles: Array<string> = [role_employer.recruiter, role_employer.psychologist, role_employer.complaint, role_employer.admin];

export const privilegesDetails = [
  {
    module: 'Atracción',
    functions: [
      { name: 'Edita Perfil Institucional', access: [true, true, true, true] },
      { name: 'Acceso a Brújula Salarial', access: [true, true, true, true] },
    ],
  },
  {
    module: 'Reclutamiento y Selección',
    functions: [
      { name: 'Crear anuncios', access: [true, true, true, true] },
      { name: 'Acceso a Buscar Talento', access: [true, true, true, true] },
      {
        name: 'Acceso a evaluaciones psicolaborales',
        access: [false, true, true, true],
      },
    ],
  },
  {
    module: 'Canal de Denuncias',
    functions: [
      { name: 'Gestión de denuncias', access: [false, false, true, true] },
    ],
  },
  {
    module: 'Mantenedores',
    functions: [
      {
        name: 'Edición de información organizativa',
        access: [false, false, false, true],
      },
    ],
  },
  {
    module: 'Administración',
    functions: [
      {
        name: 'Crea, edita y elimina otros usuarios',
        access: [false, false, false, true],
      },
    ],
  },
];
